import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "PeriodDashboardPage" */
	'pages/supplier/Period/PeriodDashboardPage'));

export default [{ component, exact: true, path: '/periods/:periodId' }];